import { InjectableService } from "@/shared/services/InjectableService";
import { RuleOrderValidationService } from "./RuleOrderValidationService";
import { Rule } from "../models/Rule";
import { RuleValidationResult } from "./RuleValidationResult";


export class RulesValidationService extends InjectableService {

    static readonly injectableKey = 'RulesValidationService';

    get injectableKey() {
        return (this.constructor as typeof RulesValidationService).injectableKey;
    }

    constructor(private readonly _ruleOrderValidationService: RuleOrderValidationService) {
        super();
    }

    public validateRules(rules: Array<Rule>): RuleValidationResult {

        let result = new RuleValidationResult();

        result = this._ruleOrderValidationService.validateRules(rules, result);

        return result;

    } 

}